import VectorImageLayer from 'ol/layer/VectorImage';
import VectorSource from 'ol/source/Vector';
import { Style } from 'ol/style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import { keyBy } from 'lodash-es';
import { getStyle} from '../../common/ki-ol-layer-generator'

export default class StationsCatchmentsLayer extends VectorImageLayer {
  constructor(options) {
    options = {
      source: new VectorSource(),
      maxZoom: 13,
      ...options
    };
    super(options);
    this.imageRatio= 2;
    this._catchments = options.catchments || [];
    this.highlighted = [];
    this.currentCatchment = options.currentCatchment;
    this._catchmentsStyles = options.catchmentsStyles || {};
    this.cachedStyle = {};
    this.cachedStyleHighlighted = {};
    this.setProperties({
      name: options.name,
      displayInLayerControl: options.displayInLayerControl,
      group: options.group,
    });
  }

  set catchmentFeatures(catchmfeat){
    this._catchmentFeatures = catchmfeat.map(feat=> {
        const id = feat.getId();
        const ret = feat.clone();
        ret.setId(id);
        return ret;
    });
    this.catchments.length && this.catchmentFeatures.length && this.createFeatures();
  }

  get catchmentFeatures(){
    return this._catchmentFeatures || [];
  }

  set catchments(catchm){
    this._catchments = catchm;
    this.catchments.length && this.catchmentFeatures.length && this.createFeatures();
  }

  get catchments(){
    return this._catchments || [];
  }

  set catchmentsStyles(styles){
    this._catchmentsStyles = styles;
    this.createStyles();
  }

  get catchmentsStyles(){
    return this._catchmentsStyles;
  }

  createStyles(){
    for (let i = 0; i < Object.entries(this._catchmentsStyles).length; i++){
      const [key, value] = Object.entries(this._catchmentsStyles)[i];
      this.cachedStyle[key] = getStyle("Polygon", value.style)
      this.cachedStyleHighlighted[key] =  getStyle("Polygon", value.highlightStyle)
    }
  }

  createFeatures() {
    this.createStyles()
    const source = this.getSource();
    source.clear();
    const catIndex = keyBy(this.catchments, "station_no")
    this.catchmentFeatures.forEach(feat => {
      const props = catIndex[feat.getId()]
      if(props){
        feat.setStyle(this._getCatchmentStyle(props));
        feat.setProperties(props)
      }else{
        feat.setStyle(this._getCatchmentStyle({__tag: "_default"}));
        feat.setProperties(props)
      }
    })
    source.addFeatures(this.catchmentFeatures);
  }

  highlight(catchment){
    this.highlighted.forEach(feat => feat.setStyle(this.cachedStyle[feat.getProperties().__tag || "_default"]))
    this.highlighted = [];
    if(catchment && catchment.station_no){
      const f = this.getSource().getFeatureById(catchment.station_no);
      f.setStyle(this.cachedStyleHighlighted[f.getProperties().__tag|| "_default"])
      this.highlighted.push(f)
    }
  }

  // eslint-disable-next-line class-methods-use-this
  _getCatchmentStyle(catchment) {
    return this.cachedStyle[catchment.__tag] || this.cachedStyle._default;
  }

  _getHoverStyle(catchment) {
    const catchmentStatus = catchment.__tag;
    const selected = this.currentCatchment && catchment.catchment_no === this.currentCatchment.catchment_no;
    const cStyle = this.catchmentsStyles[catchmentStatus] || this.catchmentsStyles._default;

    return new Style({
      fill: new Fill({
        color: cStyle.color.replace(/[^,]+(?=\))/, selected ? '0.6' : '0.5'),
      }),
      stroke: new Stroke({
        color: cStyle.stroke,
        width: selected ? 3 : 1,
      }),
    });
  }
}
